import { Injectable } from '@angular/core';

import { StorageService } from '../base/services/storage.service';

@Injectable({
    providedIn: 'root',
})
export class CatalogStorageServiceBase extends StorageService {
    public KEY: { [index: string]: string } = {
        PRODUCTS: 'products',
    };
    protected prefix: string = 'catalog_';

    protected localStorageKeys: string[] = [this.KEY.PRODUCTS];
}
